import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["count"],
  _excluded2 = ["count"];
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContentObjectType } from 'content-management-data-lib';
import { LimitTypes } from '../constants/LimitTypes';
import useContentUsageLimits from '../hooks/useContentUsageLimits';
import { getDowngradeLimitAlertMessageOptions } from '../utils/downgradeLimits';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const DowngradeLimitTitle = ({
  renderTitle,
  langKey,
  options
}) => {
  if (renderTitle) {
    const rest = _objectWithoutPropertiesLoose(options, _excluded);
    return renderTitle(rest);
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: langKey,
    options: options
  });
};
const DowngradeLimitMessage = ({
  renderMessage,
  langKey,
  options
}) => {
  if (renderMessage) {
    const rest = _objectWithoutPropertiesLoose(options, _excluded2);
    return renderMessage(rest);
  }
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: langKey,
    options: options
  });
};
const DowngradeLimitAlert = ({
  renderTitle,
  renderMessage,
  alertProps = {}
}) => {
  const {
    getHasExceededUsageLimit,
    getLimitValue,
    getAmountOverLimit
  } = useContentUsageLimits();
  const {
    contentObjectTypePluralNoun,
    contentObjectTypeSingularNoun,
    contentGroupObjectTypePluralNoun,
    contentGroupObjectTypeSingularNoun
  } = useContentObjectType();
  const hasExceededContentObjectLimit = getHasExceededUsageLimit(LimitTypes.CONTENT_OBJECT_LIMIT);
  const hasExceededContentGroupLimit = getHasExceededUsageLimit(LimitTypes.CONTENT_GROUP_LIMIT);
  if (!hasExceededContentObjectLimit && !hasExceededContentGroupLimit) {
    return null;
  }
  const contentObjectLimit = getLimitValue(LimitTypes.CONTENT_OBJECT_LIMIT);
  const contentGroupLimit = getLimitValue(LimitTypes.CONTENT_GROUP_LIMIT);
  const numContentObjectsOverLimit = getAmountOverLimit(LimitTypes.CONTENT_OBJECT_LIMIT);
  const numContentGroupObjectsOverLimit = getAmountOverLimit(LimitTypes.CONTENT_GROUP_LIMIT);
  const nouns = {
    contentObjectTypePluralNoun,
    contentObjectTypeSingularNoun,
    contentGroupObjectTypePluralNoun,
    contentGroupObjectTypeSingularNoun
  };
  const {
    dataTestId,
    langKey,
    messageOptions,
    titleOptions
  } = getDowngradeLimitAlertMessageOptions({
    contentObjectLimit,
    contentGroupLimit,
    numContentObjectsOverLimit,
    numContentGroupObjectsOverLimit,
    hasExceededContentObjectLimit,
    hasExceededContentGroupLimit
  });
  return /*#__PURE__*/_jsx(Alert, Object.assign({
    "data-test-id": dataTestId,
    titleText: /*#__PURE__*/_jsx(DowngradeLimitTitle, {
      renderTitle: renderTitle,
      langKey: `${langKey}.title`,
      options: Object.assign({}, titleOptions, nouns, {
        numContentGroupObjectsOverLimit,
        numContentObjectsOverLimit
      })
    }),
    type: "danger"
  }, alertProps, {
    children: /*#__PURE__*/_jsx(DowngradeLimitMessage, {
      renderMessage: renderMessage,
      langKey: `${langKey}.body`,
      options: Object.assign({
        contentGroupLimit,
        contentObjectLimit
      }, messageOptions, nouns)
    })
  }));
};
export default DowngradeLimitAlert;